import { createClient } from "@supabase/supabase-js";
import { env } from "@/lib/env";

const placeholderUrl = "http://127.0.0.1:54321";
const placeholderKey = "supabase-not-configured";

export const supabase = createClient(
  env.supabaseUrl || placeholderUrl,
  env.supabasePublishableKey || placeholderKey,
  {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      persistSession: true,
      flowType: "pkce",
    },
    global: {
      headers: { "X-Client-Info": "matchbase-web/1.0" },
    },
  },
);

